import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

const useLeafletControlContainer = (position = 'topright') => {
  const map = useMap(); // Leaflet map instance
  const containerRef = useRef(); // Container for the custom control (reference to leaflet div)
  const controlRef = useRef(); // Leaflet custom control instance (reference to leaflet control instance)

  useEffect(() => {
    // Creates a div element to serve as the control's container
    const container = L.DomUtil.create('div');
    // Store the container in a React ref so that React can manage it
    containerRef.current = container;

    // Creates a subclass of L.Control
    const Control = L.Control.extend({
      // Adds the control to the map
      onAdd() {
        return container;
      },
      // Cleans up when the control is removed from the map
      onRemove() {},
    });

    controlRef.current = new Control({ position });
    controlRef.current.addTo(map);

    // Cleanup function to remove the control from the map when the component unmounts
    return () => {
      if (controlRef.current) {
        controlRef.current.remove();
      }
    };
  }, [map, position]);

  return containerRef;
};
export default useLeafletControlContainer;
